export default __webpack_public_path__ + "static/media/volcan-villarrica-desde-lago.d92deab9.jpeg";